module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./libs/element-ui/~/babel-runtime/core-js/object/assign.js
// module id = 185
// module chunks = 0